export default __webpack_public_path__ + "static/Vidrios_Aluminios_7-760d70ae2a5e843f50179a578c1f3c25.png";